import { useTranslation } from 'react-i18next'
import { SummaryIcon } from '@components/CartPage/CartWithItems/CartWithItems.styles'
import { LockIcon } from '@velasca/icons/lock'
import { TagIcon } from '@velasca/icons/tag'
import { TruckIcon } from '@velasca/icons/truck'
import { SansText } from '@velasca/ui/sans-text'
import { LineDescription, LineLabelsWrapper } from './Reassurance.style'

export const Reassurance = () => {
  const { t } = useTranslation('global')

  return (
    <LineLabelsWrapper>
      <LineDescription
        css={`
          justify-content: flex-start;
          gap: 1.5rem;
        `}
      >
        <SummaryIcon>
          <TruckIcon />
        </SummaryIcon>
        <SansText
          size="md"
          dangerouslySetInnerHTML={{
            __html: t('cart_free_shipping'),
          }}
        />
      </LineDescription>
      <LineDescription
        css={`
          justify-content: flex-start;
          gap: 1.5rem;
        `}
      >
        <SummaryIcon>
          <TagIcon />
        </SummaryIcon>
        <SansText
          size="md"
          as="div"
          dangerouslySetInnerHTML={{ __html: t('cart_coupon') }}
        ></SansText>
      </LineDescription>
      <LineDescription
        css={`
          justify-content: flex-start;
          gap: 1.5rem;
        `}
      >
        <SummaryIcon>
          <LockIcon />
        </SummaryIcon>
        <SansText
          size="md"
          dangerouslySetInnerHTML={{
            __html: t('cart_secure_payment'),
          }}
        ></SansText>
      </LineDescription>
    </LineLabelsWrapper>
  )
}
